import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormTicket from "./formulario";

export function TicketIncluir() {
  const idticket = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo={`Incluir Ticket - [#Novo]`} />
        <FormTicket idticket={idticket.id} acao="Novo" />
      </div>
    </>
  );
} 